import type { OrderedSequence } from './types';

const registry = new Map<string, OrderedSequence<unknown>>();

export function registerSequence<TMember>(
  sequence: OrderedSequence<TMember>,
): void {
  if (registry.has(sequence.id)) {
    throw new Error(`OrderedSequence "${sequence.id}" is already registered`);
  }
  registry.set(sequence.id, sequence as OrderedSequence<unknown>);
}

export function getSequence(id: string): OrderedSequence<unknown> | undefined {
  return registry.get(id);
}

/** @internal Test-only reset — not part of the public runtime contract. */
export function clearSequenceRegistryForTests(): void {
  registry.clear();
}
